import { ChevronLeft } from 'lucide-react';
import { ReactNode } from 'react';
import { Button } from '../../../design-system/button/button';
import { Inline } from '../../../design-system/inline/inline';
import { Stack } from '../../../design-system/stack/stack';
import { cn } from '../../../utils/cn';

type PayrollFlowContentWrapperProps = {
  children: ReactNode;
  title: string;
  isFullScreenWidth?: boolean;
  onGoBack: () => void;
};

export const PayrollFlowContentWrapper = ({
  children,
  title,
  isFullScreenWidth = false,
  onGoBack,
}: PayrollFlowContentWrapperProps) => {
  return (
    <div
      className={cn('mx-auto my-10 w-[520px]', {
        'w-screen px-32': isFullScreenWidth,
      })}
    >
      <Stack space={3} align="stretch">
        <Inline space={3}>
          <Button variant="ghost" size="icon" className="bg-white" onClick={onGoBack} aria-label="Go back">
            <ChevronLeft size={16} />
          </Button>

          <h2 className="text-base font-medium text-black">{title}</h2>
        </Inline>
        {children}
      </Stack>
    </div>
  );
};
